export default "__VITE_ASSET__OFQIEeib__"